var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getTheCart.family_discount_amount)?_c('h3',{staticClass:"text-body-1"},[_vm._v("Family Discount ("+_vm._s(_vm.getTheCart.family_discount_pcnt_formatted)+") : -$"+_vm._s(_vm.amountInUSDFormatted))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }